import React, { useState, useEffect } from "react";
import axios from "axios";
import ReactDOM from 'react-dom';
import 'antd/dist/antd.css';
import './app.css';
import { Form, Input, Button, Checkbox, Card, Avatar, Layout, Spin } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import BasicLayout from './layout';
import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import logo from './logo2.jpg';
import { UserService } from '@gtpl/shared-services/attendance'
import { appSettings } from '../../../../../apps/services/config';
import CustomSpinner from "libs/shared-components/custom-spinner/src/lib/custom-spinner";

const App = () => {

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [user_data, setUser] = useState();
  const [load, setLoad] = useState(false);

  axios.interceptors.request.use(request => {
    setLoad(true);
    return request;
  });

  axios.interceptors.response.use(response => {
    setLoad(false);
    return response;
  }, error => {
    setLoad(false);
    throw error;
  });


  useEffect(() => {

    const loggedInUser = localStorage.getItem("user");
    if (loggedInUser) {
      setTimeout(() => setLoading(false), 1000)
      const foundUser = JSON.parse(loggedInUser);
      setUser(foundUser);
    }
  }, []);
  const [loading, setLoading] = useState(true);

  const service = new UserService();

  // logout the user
  const handleLogout = () => {
    setUsername("");
    setPassword("");
    localStorage.clear();
  };

  const onFinish = (values) => {
    console.log('Received values of form: ', values);
  };

  // login the user
  //  const handleSubmit = (values) => {
  //    service.login(values).then(response=>{
  //     if (response.status) {
  // store the user in localStorage

  // localStorage.setItem("user", JSON.stringify(response));
  // localStorage.setItem("username",JSON.stringify(response.user_data.username));
  // localStorage.setItem("createdUser",response.user_data.username);
  // localStorage.setItem("userid",response.user_data.id);
  // localStorage.setItem("expiresIn",JSON.stringify(response.expiresIn));
  // localStorage.setItem("accessToken",JSON.stringify(response.accessToken));
  // localStorage.setItem("role",JSON.stringify(response.user_data.employeeRole));
  // localStorage.setItem("unit_id",JSON.stringify(response.user_data.unitId));
  // set the state of the user

  //         setUser(response);
  //         window.location.reload();
  //         AlertMessages.getSuccessMessage('Login Successful');
  //       }else{
  //          AlertMessages.getErrorMessage('Invalid Credentials');

  //       }
  //   }).catch(err => {
  //       AlertMessages.getErrorMessage(err.message);
  //   })
  // };



  // login the user
  const handleSubmit = async (values) => {
    // e.preventDefault();
    console.log(values);
    // const user = { username, password };
    // const user ={'ramakrishna':'ramakrishna'};
    // send the username and password to the server
    // const response = await axios.post("http://139.59.32.100:4000/gtpl/auth/login",values);
    const response = await axios.post(appSettings.ums_url + '/auth/login', values);
    console.log(response);
    if (response.data.status) {
      // store the user in localStorage
      localStorage.setItem("user", JSON.stringify(response.data));
      localStorage.setItem("username", JSON.stringify(response.data.user_data.username));
      localStorage.setItem("userid", JSON.stringify(response.data.user_data.id));
      localStorage.setItem("createdUser", response.data.user_data.username);
      localStorage.setItem("expiresIn", JSON.stringify(response.data.expiresIn));
      localStorage.setItem("accessToken", JSON.stringify(response.data.accessToken));
      localStorage.setItem("role", JSON.stringify(response.data.user_data.employeeRole));
      localStorage.setItem("unit_id", JSON.stringify(response.data.user_data.unitId));

      // set the state of the user
      setUser(response.data);
      window.location.reload();
      AlertMessages.getSuccessMessage('Login Successful');
    } else {
      AlertMessages.getErrorMessage('Invalid Credentials');
    }
  };
  // if there's a user show the message below
  if (user_data) {
    // window.location.reload();
    return (
      <>
        {loading === false ? (
          <>
            <CustomSpinner loading={load} />
            <BasicLayout key={1} user={user_data} username={username} />
          </>
        ) : (
          <div className="spin">
            <CustomSpinner loading={load} />
          </div>
        )}
      </>
    );
  }

  return (
    <Form
      name="normal_login"
      className="container"
      initialValues={{
        remember: true,
      }}
      onFinish={handleSubmit}
    >

      <div className="bg-img">
        <div className="login">
          {/* <div>
          <h3 style={{color:'white', fontSize:'12px'}}>Role: Sales, [username: sales, password: sales]</h3>
          <h3 style={{color:'white', fontSize:'12px'}}>Role: Packing, [username: packing, password: packing]</h3>
          <h3 style={{color:'white', fontSize:'12px'}}>Role: Logistics, [username: logistics, password: logistics]</h3>
          <h3 style={{color:'white', fontSize:'12px'}}>Role: Admin, [username: admin, password: admin]</h3>
        </div> */}
          <div className="imgcontainer">
            <img src={logo} />
          </div>
          <header>Login </header>

          <Form.Item
            name="username"
            rules={[
              {
                required: true,
                message: 'Please input your Username!',
              },
            ]}
          >
            <Input prefix={<UserOutlined className="site-form-item-icon" />} placeholder="Username" />
          </Form.Item>


          <Form.Item
            name="password"
            rules={[
              {
                required: true,
                message: 'Please input your Password!',
              },
            ]}
          >
            <Input
              prefix={<LockOutlined className="site-form-item-icon" />}
              type="password"
              placeholder="Password"
            />
          </Form.Item>

          {/* <Form.Item>
        <Form.Item name="remember" valuePropName="checked" noStyle>
          <Checkbox>Remember me</Checkbox>
        </Form.Item>

        <a className="login-form-forgot" href="">
          Forgot password
        </a>
      </Form.Item> */}
          <Form.Item>
            <Button type="primary" htmlType="submit" className="login-form-button ">
              Log in
            </Button>
            {/* Or <a href="">register now!</a> */}
          </Form.Item>
        </div>
      </div>

    </Form>


  );
};

// ReactDOM.render(<NormalLoginForm />, document.getElementById('container'));
export default App;
